const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** List age: "now", "5m", "3h", "4d", then "Sep 14" (local time) from a week on. */
export function formatAge(ts: number, now: number, tzOffsetMin = 0): string {
  const d = now - ts;
  if (d < 60_000) return "now";
  const m = Math.floor(d / 60_000);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days}d`;
  const local = new Date(ts - tzOffsetMin * 60_000);
  return `${MONTHS[local.getUTCMonth()]} ${local.getUTCDate()}`;
}

/** Calendar-day index in local time, for grouping. tzOffsetMin follows Date#getTimezoneOffset. */
const dayIndex = (ts: number, tzOffsetMin: number) => Math.floor((ts - tzOffsetMin * 60_000) / 86_400_000);

/** Group label for a publication time: Today, Yesterday, a weekday within the week, else "Older". */
export function timeGroup(ts: number, now: number, tzOffsetMin = 0): { key: string; label: string } {
  const diff = dayIndex(now, tzOffsetMin) - dayIndex(ts, tzOffsetMin);
  if (diff <= 0) return { key: "d0", label: "Today" };
  if (diff === 1) return { key: "d1", label: "Yesterday" };
  if (diff < 7) {
    const local = new Date(ts - tzOffsetMin * 60_000);
    return { key: `d${diff}`, label: `${DAYS[local.getUTCDay()]}, ${MONTHS[local.getUTCMonth()]} ${local.getUTCDate()}` };
  }
  return { key: "older", label: "Older" };
}

/** Group label for Recently read: the day you read it. */
export function readDayGroup(ts: number, now: number, tzOffsetMin = 0): { key: string; label: string } {
  const diff = dayIndex(now, tzOffsetMin) - dayIndex(ts, tzOffsetMin);
  if (diff <= 0) return { key: "r0", label: "Today" };
  if (diff === 1) return { key: "r1", label: "Yesterday" };
  const local = new Date(ts - tzOffsetMin * 60_000);
  return { key: `r${diff}`, label: `${DAYS[local.getUTCDay()]}, ${MONTHS[local.getUTCMonth()]} ${local.getUTCDate()}` };
}
